export default __webpack_public_path__ + "static/media/img18.8bb0ab3b.svg";